import React from 'react';

import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CopyIcon } from '@pkg/assets/icons/v2/copy-wide.svg';
import { useCopyLink } from '@pkg/hooks';

import { LinkButton, SuccessToast, Wrapper } from './styles';
interface Props {
    href: string;
    hovering: boolean;
}

export const GroupCopyLink = ({ href, hovering }: Props) => {
    const { showCopyToast, handleLinkCopy } = useCopyLink();
    const { t: translate } = useTranslation(['copy_widget']);

    return (
        <Wrapper $hovering={hovering}>
            <LinkButton onClick={handleLinkCopy}>
                <CopyIcon />
            </LinkButton>
            <AnimatePresence>
                {showCopyToast && (
                    <SuccessToast
                        key={`success_${href}`}
                        initial={{ opacity: 0, left: `calc(100% + 15px)` }}
                        animate={{ opacity: 1, left: `calc(100% + 5px)` }}
                        exit={{ opacity: 0, left: `calc(100% + 15px)` }}
                    >
                        {translate('link_copied')}
                    </SuccessToast>
                )}
            </AnimatePresence>
        </Wrapper>
    );
};
